'use strict';

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".jthreads-container {\n  width: 100%;\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.jthreads-container .MuiCircularProgress-colorPrimary {\n  color: #000000;\n}\n.jthreads-container .MuiCircularProgress-root {\n  display: inline-block;\n}\n.jthreads-container .MuiCircularProgress-svg {\n  display: block;\n}\n@keyframes circularRotate {\n  0% {\n    transform-origin: 50% 50%;\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes circularDash {\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0px;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n}\n.jthreads-container .MuiCircularProgress-indeterminate {\n  animation: circularRotate 1.4s linear infinite;\n}\n.jthreads-container .MuiCircularProgress-circleIndeterminate {\n  animation: circularDash 1.4s ease-in-out infinite;\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0px;\n}\n.jthreads-container .MuiCircularProgress-circle {\n  stroke: currentColor;\n}");